import { GalleryMedia } from '../types/scrolling-gallery.types';

export const galleryImages: GalleryMedia[] = [
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1382.webp',
        type: 'image',
        alt: 'Submitted',
        width: '16rem',
        marginTop: '2.4375rem',
        marginLeft: '10rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '2.1875rem',
        mobileMarginLeft: '15.8125rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/20/895e2d171fef426c9416c401d935d703-image2-(2).jpg',
        type: 'image',
        alt: 'Submitted',
        width: '12.375rem',
        marginTop: '3.25rem',
        marginLeft: '3rem',
        mobileWidth: '9.3125rem',
        mobileMarginTop: '2.625rem',
        mobileMarginLeft: '2rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/20/5e7497e438884fbfb677be6463d303e0-IMG_20250126_141817---Lucy-Oyelade-(1).jpg',
        type: 'image',
        alt: 'Submitted',
        width: '14rem',
        marginTop: '6.4375rem',
        marginLeft: '2rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '4.625rem',
        mobileMarginLeft: '11rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/07/05/d7cab87f02294e7ba5c1182bfaa7d311-2026-02-18-11.59.49.jpg',
        type: 'image',
        alt: 'Submitted',
        width: '12.375rem',
        marginTop: '4.5rem',
        marginLeft: '2rem',
        mobileWidth: '9.3125rem',
        mobileMarginTop: '3.0625rem',
        mobileMarginLeft: '3rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-laurajackson.webp',
        type: 'image',
        alt: '@laurajackson',
        width: '14rem',
        marginTop: '2.4375rem',
        marginLeft: '2rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '2.1875rem',
        aspectRatio: '9/16'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1388.webp',
        type: 'image',
        alt: 'Submitted',
        width: '10rem',
        marginTop: '6.4375rem',
        marginLeft: '6rem',
        mobileWidth: '12.75rem',
        mobileMarginTop: '5.1875rem',
        mobileMarginLeft: '2rem',
        mobileMarginBottom: 'auto',
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/video/ugc-designersvane.mp4',
        type: 'video',
        alt: '@designersvane',
        width: '14rem',
        marginTop: '2.4375rem',
        marginLeft: '6rem',
        mobileWidth: '9.75rem',
        mobileMarginTop: '3.1875rem',
        mobileMarginLeft: '2.5rem',
        mobileMarginBottom: 'auto',
        autoplay: true,
        loop: true,
        muted: true,
        aspectRatio: '9/15'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-noahbier.webp',
        type: 'image',
        alt: '@noahbier',
        width: '10rem',
        marginTop: '2.1875rem',
        marginLeft: '4rem',
        mobileWidth: '9.3125rem',
        mobileMarginTop: '-4.0625rem',
        mobileMarginLeft: '1.5rem',
        mobileMarginBottom: 'auto',
        autoplay: true,
        loop: true,
        muted: true
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1476.webp',
        type: 'image',
        alt: 'Submitted',
        width: '12.375rem',
        marginTop: '2.1875rem',
        marginLeft: '2rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '3.0625rem',
        mobileMarginLeft: '13rem',
        mobileMarginBottom: 'auto',
        aspectRatio: '9/16'
    },
    // {
    //     url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1447.webp',
    //     type: 'image',
    //     alt: 'Submitted',
    //     width: '18rem',
    //     marginTop: '5.5rem',
    //     marginLeft: '0rem',
    //     mobileWidth: '10.3125rem',
    //     mobileMarginTop: '2.1875rem'
    // },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1430.webp',
        type: 'image',
        alt: 'Submitted',
        width: '12.375rem',
        marginTop: '8.3125rem',
        mobileWidth: '9.3125rem',
        mobileMarginTop: '4.625rem',
        mobileMarginLeft: '12.8125rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1456.webp',
        type: 'image',
        alt: 'Submitted',
        width: '18rem',
        marginTop: '5.5rem',
        marginLeft: '0rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '2.1875rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1447.webp',
        type: 'image',
        alt: 'Submitted',
        width: '18rem',
        marginTop: '5.5rem',
        marginLeft: '0rem',
        mobileWidth: '10.3125rem',
        mobileMarginTop: '2.1875rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-lacabinedemargaux.webp',
        type: 'image',
        alt: '@lacabinedemargaux',
        width: '12.375rem',
        marginTop: '5.3125rem',
        mobileWidth: '9.3125rem',
        mobileMarginTop: '2.625rem',
        mobileMarginRight: '1.8125rem'
    },
    {
        url: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/ugc/images/ugc-submitted_1393.webp',
        type: 'image',
        alt: 'Submitted',
        width: '10.375rem',
        marginTop: '12.3125rem',
        marginLeft: '1rem',
        mobileWidth: '7.3125rem',
        mobileMarginTop: '5.625rem',
        mobileMarginLeft: '12rem'
    }
]; 
